<div class="chips d-flex flex-wrap align-items-center">
  <ng-container *ngFor="let data of chipsList; index as i">
    <div *ngIf="i < limitShow || showMore" class="rounded-pill chip-{{ data.id }} chip " matRipple>
      <span class="text-{{ labelTextStyle }}">{{ data.name | lowercase }} {{ data.area ? ', ' + (data.area | lowercase) : '' }}</span>
      <span *ngIf="!disabled" (click)="handleRemoveChip(data)" [inlineSVG]="STRING_CONSTANTS.ICON.IC_X" class="svg-icon svg-icon-2 cursor-pointer ms-2"></span>
    </div>
  </ng-container>
  <ng-container *ngIf="chipsList && chipsList.length > 5">
    <div class="d-flex no-chip justify-content-between cursor-pointer">
      <span (click)="toggleShowMore()" class="fw-bold text-decoration-underline">{{ showMore ? 'Hide' : '+' + (chipsList.length - limitShow) + ' More' }}</span>
    </div>
  </ng-container>
</div>
